// extracted by mini-css-extract-plugin
export default {"cls1":"AccountMenuButton-cls1__d866cfb90065c031fd43","cls2":"AccountMenuButton-cls2___c05eb4c5cab12cab1ef AccountMenuButton-cls1__d866cfb90065c031fd43"};